import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {  axiosWhitelabeled } from '../../../../axios';
import { AUTH_TOKEN } from '../../../../environments';
import { moduleName } from '../../moduleInfo';
import {
  getAllAppListRoute, patchAppAproveReject, patchAppListRoute, postAllAppListRoute,
} from '../../utils/apiRoutes';

export const getAllAppListRouteAsync = createAsyncThunk(
  `${moduleName}/getAllAppListRouteAsync`,
  async (payload) => {
    const response = await axiosWhitelabeled({
      method: 'GET',
      url: getAllAppListRoute(),
			// data:payload,
			params:{...payload},
			headers: {
        Authorization: AUTH_TOKEN,
      },
    });
    const data = response.data;
		console.log('this is',data);
    return data;
  }
);

export const patchAppListAsync = createAsyncThunk(
  `${moduleName}/patchAppListAsync`,
  async (payload) => {
		console.log('bagade',payload)
		// console.log('keyy',AUTH_TOKEN)
    const response = await axiosWhitelabeled({
      method: 'PATCH',
      url: patchAppListRoute(payload._id),
      data: payload,
    });
		
    const data = response.data;
		console.log('that is',data);
    return data;
    // return response.data;
  }
);

export const patchApproveRejectAsync = createAsyncThunk(
  `${moduleName}/patchApproveRejectAsync`,
  async (payload) => {
    const response = await axiosWhitelabeled({
      method: 'PATCH',
      url: patchAppAproveReject(payload._id),
      data: payload,
    });
    const data = response.data;
    return data;
    // return response.data;
  }
);

export const postAppsAsync = createAsyncThunk(
  `${moduleName}/postAppsAsync`,
  async (payload) => {
    const response = await axiosWhitelabeled({
      method: 'POST',
      url: postAllAppListRoute(payload._id),
      data: payload,
			headers: {
        Authorization: AUTH_TOKEN,
      },
    });
    const data = response.data;
    return data;
  }
);

const AppListSlice = createSlice({
  name: `${moduleName}/AppList`,
  initialState: {
    loading: false,
    listapps: [],
		totalapps:[],
    // oneuser: [],
		postapp:null,
    patchapp: null,
		patchrejectapprove:null,
  },
  reducers: {},
  extraReducers: {
    [getAllAppListRouteAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [getAllAppListRouteAsync.fulfilled]: (state, action) => {
      console.log('test987654321', action.payload);
      state.loading = false;
      state.listapps = action.payload.data;
			state.totalapps=action.payload;
    },
    [getAllAppListRouteAsync.rejected]: (state, action) => {
      state.loading = false;
    },
    [postAppsAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [postAppsAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.postapp = action.payload;
    },
    [postAppsAsync.rejected]: (state, action) => {
      state.loading = false;
    },
    [patchAppListAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [patchAppListAsync.fulfilled]: (state, action) => {
			console.log('test2', action, action.payload);
      state.loading = false;
      state.patchapp = action.payload;
    },
    [patchAppListAsync.rejected]: (state, action) => {
      state.loading = false;
    },
    // delete one user
    [patchApproveRejectAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [patchApproveRejectAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.patchrejectapprove = action.payload;
    },
    [patchApproveRejectAsync.rejected]: (state, action) => {
      state.loading = false;
    },
  },
});

export default AppListSlice.reducer;
